var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTranslation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "25px",
    height: "25px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 25 25",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsXodm: "http://www.corel.com/coreldraw/odm/2003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .fil0 {fill:#757575}\n    .fil1 {fill:#FEFEFE}\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M11.91 6.18c3.65,-0.33 6.56,2.38 6.89,5.63 0.38,3.72 -2.39,6.63 -5.65,6.97 -3.69,0.39 -6.65,-2.41 -6.95,-5.69 -0.34,-3.7 2.4,-6.61 5.71,-6.91zm-11.86 6.9c0.3,6.66 5.98,12.19 13.05,11.85 6.68,-0.33 12.2,-5.97 11.85,-13.08 -0.34,-6.65 -5.98,-12.18 -13.07,-11.82 -6.68,0.35 -12.15,5.95 -11.83,13.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M13.67 15.02c-0.03,0.53 -0.85,2.16 -1.15,2.44 -0.26,-0.16 -0.58,-0.87 -0.72,-1.15 -0.16,-0.32 -0.44,-0.93 -0.47,-1.29l2.34 0zm0.54 2.19c0.06,-0.28 0.33,-0.75 0.45,-1.09 0.15,-0.37 0.24,-0.77 0.37,-1.11l1.8 0.02c-0.11,0.59 -1.7,2.03 -2.62,2.18zm-3.41 0c-0.53,-0.1 -1.31,-0.62 -1.59,-0.89 -0.28,-0.26 -0.94,-0.88 -1.04,-1.3l1.78 0.01c0.1,0.15 0.3,0.87 0.4,1.12 0.14,0.39 0.35,0.71 0.45,1.06zm0.22 -5.93c0.25,-0.13 2.57,-0.1 2.96,-0.04 0.11,0.61 0.24,1.98 -0.04,2.5 -0.49,0.03 -2.59,0.08 -2.93,-0.05 -0.11,-0.68 -0.15,-1.77 0.01,-2.41zm4.25 2.47c0.08,-0.99 0.04,-1.57 0.01,-2.54l2.13 0c0.2,1.03 0.2,1.5 0.01,2.54l-2.15 0zm-7.58 0c-0.16,-0.11 -0.06,0.07 -0.16,-0.26 -0.17,-0.6 -0.08,-1.65 0.07,-2.27l2.13 0.01c-0.08,0.97 -0.06,1.54 0,2.52l-2.04 0zm3.63 -3.8c0.11,-0.62 0.86,-2.24 1.2,-2.45 0.34,0.33 1.06,1.84 1.17,2.44l-2.37 0.01zm-3.16 -0.03c0.27,-0.78 1.73,-2 2.64,-2.18 -0.1,0.33 -0.33,0.75 -0.46,1.1 -0.12,0.31 -0.22,0.83 -0.39,1.11l-1.79 -0.03zm6.87 0c-0.15,-0.31 -0.26,-0.82 -0.39,-1.15 -0.13,-0.34 -0.34,-0.71 -0.44,-1.02 0.93,0.13 2.41,1.49 2.64,2.2l-1.81 -0.03zm-3.12 -3.74c-3.31,0.3 -6.05,3.21 -5.71,6.91 0.3,3.28 3.26,6.08 6.95,5.69 3.26,-0.34 6.03,-3.25 5.65,-6.97 -0.33,-3.25 -3.24,-5.96 -6.89,-5.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M11.02 11.28c-0.16,0.64 -0.12,1.73 -0.01,2.41 0.34,0.13 2.44,0.08 2.93,0.05 0.28,-0.52 0.15,-1.89 0.04,-2.5 -0.39,-0.06 -2.71,-0.09 -2.96,0.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M15.27 13.75l2.15 0c0.19,-1.04 0.19,-1.51 -0.01,-2.54l-2.13 0c0.03,0.97 0.07,1.55 -0.01,2.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M7.69 13.75l2.04 0c-0.06,-0.98 -0.08,-1.55 0,-2.52l-2.13 -0.01c-0.15,0.62 -0.24,1.67 -0.07,2.27 0.1,0.33 0,0.15 0.16,0.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M11.32 9.95l2.37 -0.01c-0.11,-0.6 -0.83,-2.11 -1.17,-2.44 -0.34,0.21 -1.09,1.83 -1.2,2.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M12.52 17.46c0.3,-0.28 1.12,-1.91 1.15,-2.44l-2.34 0c0.03,0.36 0.31,0.97 0.47,1.29 0.14,0.28 0.46,0.99 0.72,1.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M8.16 9.92l1.79 0.03c0.17,-0.28 0.27,-0.8 0.39,-1.11 0.13,-0.35 0.36,-0.77 0.46,-1.1 -0.91,0.18 -2.37,1.4 -2.64,2.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M14.21 17.21c0.92,-0.15 2.51,-1.59 2.62,-2.18l-1.8 -0.02c-0.13,0.34 -0.22,0.74 -0.37,1.11 -0.12,0.34 -0.39,0.81 -0.45,1.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M10.8 17.21c-0.1,-0.35 -0.31,-0.67 -0.45,-1.06 -0.1,-0.25 -0.3,-0.97 -0.4,-1.12l-1.78 -0.01c0.1,0.42 0.76,1.04 1.04,1.3 0.28,0.27 1.06,0.79 1.59,0.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M15.03 9.92l1.81 0.03c-0.23,-0.71 -1.71,-2.07 -2.64,-2.2 0.1,0.31 0.31,0.68 0.44,1.02 0.13,0.33 0.24,0.84 0.39,1.15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTranslation);
export default __webpack_public_path__ + "static/media/icon-translation.cec681c329e6fb5213d50309ad51fd7e.svg";
export { ForwardRef as ReactComponent };